import * as types from './actionTypes';

export const updateBackgroundImage = (imageFile) => ({
    type: types.UpdateBackgroundImage,
    imageFile
});

export const updateHeaderImage = (imageFile) => ({
    type: types.UpdateHeaderImage,
    imageFile
});

export const updateAvatarImage = (imageFile) => ({
    type: types.UpdateAvatarImage,
    imageFile
});

export const updateGalleryImage = (imageFile,position) => ({
    type: types.UpdateGalleryImage,
    imageFile,
    position
});

export const addGalleryImages = (imageFiles) => ({
    type: types.AddGalleryImages,
    imageFiles
});

export const removeGalleryImages = (imageFilesToDelete) => ({
    type: types.RemoveGalleryImages,
    imageFilesToDelete
});